const permissionDatas = [
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_CREATE_BUTTON",
    resourceName: "PROMO_CAMPAIGN_CREATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_CREATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_CREATE_TICKETS_BUTTON",
    resourceName: "PROMO_CAMPAIGN_CREATE_TICKETS_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_CREATE_TICKETS_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_DEACTIVATE_BUTTON",
    resourceName: "PROMO_CAMPAIGN_DEACTIVATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_DEACTIVATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_DUPLICATE_BUTTON",
    resourceName: "PROMO_CAMPAIGN_DUPLICATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_DUPLICATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_EDIT_BUTTON",
    resourceName: "PROMO_CAMPAIGN_EDIT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_EDIT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_EXTEND_PROMO_BUTTON",
    resourceName: "PROMO_CAMPAIGN_EXTEND_PROMO_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_EXTEND_PROMO_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_SEND_TICKETS_BUTTON",
    resourceName: "PROMO_CAMPAIGN_SEND_TICKETS_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_SEND_TICKETS_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_CAMPAIGN_SUBMIT_BUTTON",
    resourceName: "PROMO_CAMPAIGN_SUBMIT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_CAMPAIGN_SUBMIT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_CREATE_BUTTON",
    resourceName: "PROMO_COUPON_CREATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_CREATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_DEACTIVATE_BUTTON",
    resourceName: "PROMO_COUPON_DEACTIVATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_DEACTIVATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_DUPLICATE_BUTTON",
    resourceName: "PROMO_COUPON_DUPLICATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_DUPLICATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_EDIT_BUTTON",
    resourceName: "PROMO_COUPON_EDIT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_EDIT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_EXPORT_BUTTON",
    resourceName: "PROMO_COUPON_EXPORT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_EXPORT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_EXTEND_PROMO_BUTTON",
    resourceName: "PROMO_COUPON_EXTEND_PROMO_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_EXTEND_PROMO_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_GENERATE_BUTTON",
    resourceName: "PROMO_COUPON_GENERATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_GENERATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_SEND_BUTTON",
    resourceName: "PROMO_COUPON_SEND_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_SEND_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_SUBMIT_BUTTON",
    resourceName: "PROMO_COUPON_SUBMIT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_SUBMIT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_COUPON_VIEW_STATISTIC_BUTTON",
    resourceName: "PROMO_COUPON_VIEW_STATISTIC_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_COUPON_VIEW_STATISTIC_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_CREATE_BUTTON",
    resourceName: "PROMO_PROMOTION_CREATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_CREATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_DEACTIVATE_BUTTON",
    resourceName: "PROMO_PROMOTION_DEACTIVATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_DEACTIVATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_DUPLICATE_BUTTON",
    resourceName: "PROMO_PROMOTION_DUPLICATE_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_DUPLICATE_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_EDIT_BUTTON",
    resourceName: "PROMO_PROMOTION_EDIT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_EDIT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_EXTEND_PROMO_BUTTON",
    resourceName: "PROMO_PROMOTION_EXTEND_PROMO_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_EXTEND_PROMO_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_SUBMIT_BUTTON",
    resourceName: "PROMO_PROMOTION_SUBMIT_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_SUBMIT_BUTTON",
    __typename: "ResourceInfo"
  },
  {
    appCode: "PROMOTION",
    resourceParent: "root",
    resourceCode: "PROMO_PROMOTION_SUBMIT_PRODUCT_CONDITION_BUTTON",
    resourceName: "PROMO_PROMOTION_SUBMIT_PRODUCT_CONDITION_BUTTON",
    resourceType: 4,
    resourceClass: 1,
    accessType: 3,
    positionCode: "PROMO_PROMOTION_SUBMIT_PRODUCT_CONDITION_BUTTON",
    __typename: "ResourceInfo"
  }
];

export default permissionDatas;
